var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateModal',{ref:"modal",attrs:{"text":{
    button: {
      open: _vm.localStorage.translations.pages['sales_project']['planned_resources-subscribers']
        .add_project,
      create: _vm.localStorage.translations.pages.common.buttons['sohranit'],
    },
    title: {
      create:
        _vm.localStorage.translations.pages['sales_project']['planned_resources-subscribers']
          .add_project,
    },
  },"center":"","width":"750","sendFunction":_vm.onSubscriberCreateOrUpdate}},[_c('div',{staticClass:"send"},[_c('BaseInput',{attrs:{"label":_vm.localStorage.translations.pages['sales_project']['planned_resources-subscribers']
          .subscriber,"type":"autocomplete","items":_vm.commonUserSubscribersAll,"item-text":(i) => i.first_name + ' ' + i.last_name,"rules":['required']},model:{value:(_vm.user_id),callback:function ($$v) {_vm.user_id=$$v},expression:"user_id"}}),_c('BaseInput',{attrs:{"label":_vm.localStorage.translations.pages.planning_orders.table.proekt,"type":"autocomplete","items":_vm.projectsReady,"multiple":"","chips":"","deletable-chips":"","rules":['required'],"disabled":!_vm.user_id},model:{value:(_vm.projects_subscriptions),callback:function ($$v) {_vm.projects_subscriptions=$$v},expression:"projects_subscriptions"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }